export const getRequirementText = (requirement) => {
  if (!requirement || typeof requirement !== 'object') {
    return '';
  }

  const candidates = [
    requirement.editedText,
    requirement.sourceText,
    requirement.fullText,
    requirement.text,
    requirement.originalText,
  ];

  const match = candidates.find((value) => typeof value === 'string' && value.trim().length > 0);
  return match ? match.trim() : '';
};

const resolveNumber = (value) => {
  if (value == null) return null;
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const normalizeRequirement = (requirement) => {
  if (!requirement || typeof requirement !== 'object') {
    return {};
  }

  const normalized = { ...requirement };
  const meta = normalized.meta || normalized.metadata;
  if (meta && typeof meta === 'object') {
    normalized.meta = meta;
    normalized.type = normalized.type || meta.type || meta.category || meta.kind;
    normalized.typeReason = normalized.typeReason || normalized.type_reason || meta.typeReason || meta.type_reason;
    normalized.sourceFile = normalized.sourceFile || meta.sourceFile || meta.file;
    normalized.sourcePage = normalized.sourcePage ?? meta.sourcePage ?? meta.page;
    normalized.chunkIndex = normalized.chunkIndex ?? resolveNumber(meta.chunkIndex);
    normalized.spanStart = normalized.spanStart ?? resolveNumber(meta.spanStart);
    normalized.spanEnd = normalized.spanEnd ?? resolveNumber(meta.spanEnd);
    normalized.seqNumber = normalized.seqNumber ?? resolveNumber(meta.seqNumber);
  }

  if (!normalized.typeReason && typeof normalized.type_reason === 'string') {
    normalized.typeReason = normalized.type_reason;
  }
  if (!normalized.userFeedback && typeof normalized.user_feedback === 'string') {
    normalized.userFeedback = normalized.user_feedback;
  }

  const text = getRequirementText(normalized);
  if (text && !normalized.sourceText) {
    normalized.sourceText = text;
  }

  return normalized;
};

export const buildSourceLabel = (requirement) => {
  if (!requirement) return '';
  const parts = [];
  if (requirement.sourceFile) parts.push(requirement.sourceFile);
  const sourcePage = resolveNumber(requirement.sourcePage);
  if (sourcePage != null) parts.push(`стр. ${sourcePage}`);
  const chunkIndex = resolveNumber(requirement.chunkIndex);
  if (chunkIndex != null) parts.push(`чанк ${chunkIndex}`);
  return parts.join(', ');
};

export const summarizeRequirementMeta = (requirement) => {
  if (!requirement || typeof requirement !== 'object') {
    return [];
  }

  const meta = [];
  const type = requirement.type || requirement.kind;
  if (type) {
    meta.push({ label: 'Тип', value: type });
  }
  if (typeof requirement.typeReason === 'string' && requirement.typeReason.trim().length > 0) {
    meta.push({ label: 'Обоснование типа', value: requirement.typeReason.trim() });
  }
  const source = buildSourceLabel(requirement);
  if (source) {
    meta.push({ label: 'Источник', value: source });
  }
  const spanStart = resolveNumber(requirement.spanStart);
  const spanEnd = resolveNumber(requirement.spanEnd);
  if (spanStart != null || spanEnd != null) {
    const spanLabel =
      spanStart != null && spanEnd != null
        ? `${spanStart}–${spanEnd}`
        : spanStart != null
          ? `${spanStart}+`
          : `${spanEnd}`;
    meta.push({ label: 'Диапазон', value: spanLabel });
  }

  return meta;
};
